import HeroSection from "../components/HeroSection";
import MarqueeBanner from "../components/MarqueeBanner";
import FeaturedProducts from "../components/FeaturedProducts";
import AboutSection from "../components/AboutSection";
import TrustBadges from "../components/TrustBadges";
import Newsletter from "../components/Newsletter";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <SEO
        path="/"
        description="Padlr. is a premium Swiss padel clothing brand. Performance t-shirts, shorts & socks for the court and the street. New collection end of Oktober. Better Than Yesterday. | Premium Padel Bekleidung aus der Schweiz. Neue Kollektion Ende Oktober."
      />
      <HeroSection />
      <MarqueeBanner />
      <FeaturedProducts />
      <AboutSection />
      <TrustBadges />
      <Newsletter />
      <Footer />
    </main>
  );
}
